import { render, staticRenderFns } from "./userView.vue?vue&type=template&id=b4b15fa6&scoped=true&"
import script from "./userView.vue?vue&type=script&lang=js&"
export * from "./userView.vue?vue&type=script&lang=js&"
import style0 from "./userView.vue?vue&type=style&index=0&id=b4b15fa6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b15fa6",
  null
  
)

export default component.exports